import React, { useState, useEffect, useCallback, useLayoutEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
// import { styled } from '@mui/material/styles';
// import Iconify from '../../../components/iconify';
import CircularProgress from '@mui/material/CircularProgress';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl, { useFormControl } from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Helmet } from 'react-helmet-async';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { Icon } from '@iconify/react';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';

import moment from 'moment';
import {
    Input,
    Slide,
    IconButton,
    ClickAwayListener,
    InputBase,
    Typography,
    Table,
    Button,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Stack,
    Modal,
    Box,
    TextField,
    Divider,
    Grid,
    MenuItem,
    InputLabel,
    Select,
    FormLabel,
    FormControlLabel,
    RadioGroup,
    Radio,
    InputAdornment,
    useTheme,
    Switch,
    Checkbox,
    Avatar
} from '@mui/material';

import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';

import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';
import { Document, Page, pdfjs } from 'react-pdf';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CustomComplete from '../components/customComplete/CustomComplete';
import CustomCompleteWorksheet from '../components/customComplete/CustomCompleteWorksheet';
import Iconify from '../components/iconify';
// import Upload from '../components/upload';  
import MyCustomUploadAdapterPlugin from './customEditor/customEditor'; 
import Scrollbar from '../components/scrollbar/Scrollbar';

import { Api, UploadFile } from '../webservices';

const tablebg = 'rgba(82, 130, 190, 0.08)';
const filter = createFilterOptions();

const OpenJobs = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [jobData, setJobData] = useState([])
    const [loadingJobs, setLoadingJobs] = useState('')
    const [loadingJobsCount, setLoadingJobsCount] = useState('')
    const [pagesJobs, setPagesJobs] = useState(null)
    const [tempList, setTempList] = useState([])
    const [pageNumber, setPageNumber] = useState(1)

    useEffect(() => {
        getTemplList()
        openJobBench()
    }, []);

    const openJobBench = (page) => {
        setJobData([])
        setLoadingJobsCount('')
        setPagesJobs('')
        setLoadingJobs('Loading...')
        const body = {
            "page": page || 1,
            "limit": "35"
        }
        const token = localStorage.getItem('token');
        Api('bench/openJob', 'POST', body, token)
            .then((response) => {
                console.log('Response:---------', response);
                if (response.status === 200) {
                    setJobData(response.data?.newArray);
                    setLoadingJobsCount(response.data.count)
                    const totalPage = Math?.ceil(response.data?.count / 35)
                    setPagesJobs(totalPage)
                    setLoadingJobs('')
                } else {
                    setLoadingJobs('No data found')
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const handlePage = (event, value) => {
        setPageNumber(value);
        openJobBench(value);
    };

    const getTemplList = () => {
        const token = localStorage.getItem('token');
        // console.log("token ===>>>>> ",token)
        Api('email/getEmailTemplateList', 'GET', '', token)
            .then((response) => {
                console.log('Response:---------', response);
                if (response.status === 200) {
                    if (response.data.code === 200) {
                        //  console.log("hhh")

                    } else {
                        console.log('data:', response.data.message);
                    }
                }
                setTempList(response.data.result);
                // setUserId(response.data.result.userId)
                // setCompanyId(response.data.result.companyId)
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const [searchResult, setSearchResult] = React.useState();
    const [tableShow, setTableShow] = useState(false)

    const searchDataFun = (data) => {
        console.log("data=========>>>>>>", data)
        setJobData(null)
        if (data.noData === "noData") {
            setJobData(null)
            setLoadingJobs("No data found")
        } else {
            // setTable11(null)
            // if (valuee !== 'worksheet') {
            //   setValuee('worksheet')
            // }
            // setTable11(data || 0)
            setSearchResult(data?.length)
            // setPinned(true)
            setTableShow(true)
            setJobData(data)
        }
    }

    const resetDataFun = () => {
        openJobBench()
        setTableShow(false)
    }

    return (

        <>
        <Helmet>
        <title> Open Jobs | Foxearch </title>
      </Helmet>
            <Search
                searchData={searchDataFun}
                func={resetDataFun}
                // funcc={hidePage} funnc={showtable}
                // onData={handleDataFromChild}
                // onData1={handleDataFromChild1}
                // onData2={handleDataFromChild2}
                resetSearch={() => setSearchResult('')}
            />
            {/* {toggleButton && (
        <Button color="custom" variant="contained" size="small"
          style={{ marginLeft: '275px', marginTop: "12px", position: "absolute" }}
          onClick={resetDataFun1}
        >
          Close
        </Button>

      )} */}

            <Iconify icon="ion:arrow-back" fontSize={25} sx={{
                cursor: 'pointer', color: 'text.secondary',
                fontSize: '0.9rem', fontWeight: '600', mr: 1, mt: -2
            }}
                onClick={() => navigate(-1)} />
            <ToastContainer />

            <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center">
                <Typography variant="h5" color="textSecondary">
                    Jobs
                </Typography>

                {tableShow && (
                    <Typography sx={{ fontSize: "0.85rem", color: "text.secondary", mb: -1 }}>
                        Total: {searchResult || "0"}
                    </Typography>
                )}
            </Stack>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '12%' }}>Date</TableCell>

                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '12%' }}>Role</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Job Info</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Compensation</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Contact</TableCell>
                            <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        <JobResume
                            // key={jobData._id}
                            jobData={jobData}
                            //   openJob={openJob}
                            // index={index}
                            tempList={tempList}
                            openJobBench={openJobBench}
                            loadingJobs={loadingJobs}
                            loadingJobsCount={loadingJobsCount}
                            pagesJobs={pagesJobs}
                        />

                    </TableBody>
                </Table>
            </TableContainer>

            {loadingJobs !== "" && (
                <Stack sx={{ mt: 1.4, p: 2 }}>
                    <Typography sx={{ alignSelf: 'center', color: 'red' }}>{loadingJobs}</Typography>
                </Stack>
            )}

            {loadingJobsCount > 35 ? (
                <Stack
                    spacing={2}
                    sx={{
                        width: '100%',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        mt: 1.1,
                        mb: 1
                    }}
                >

                    <Button
                        variant="outlined"
                        sx={{
                            minWidth: 16, height: 32, borderRadius: '5px',
                            mt: 2,
                            ml: 0.5, cursor: 'pointer'
                        }}
                        onClick={() => setPageNumber(prev => Math.max(prev - 1, 1))}
                    >
                        {"<"}
                    </Button>

                    <Pagination
                        variant="outlined"
                        shape="rounded"
                        color="secondary"
                        hideNextButton
                        hidePrevButton
                        count={pagesJobs}
                        page={pageNumber}
                        onChange={handlePage}
                        sx={{ cursor: 'pointer', mb: (pageNumber !== 1) ? -4 : -2 }}
                    />

                    <Button
                        variant="outlined"
                        sx={{
                            minWidth: 16, height: 32, borderRadius: '5px', mr: 1,
                            mt: -2,
                            cursor: 'pointer'
                        }}
                        onClick={() => setPageNumber(prev => Math.min(prev + 1, pagesJobs))}
                    >
                        {">"}
                    </Button>

                </Stack>

            ) : null}

        </>

    );
};

export default OpenJobs;

const JobResume = ({ jobData, tempList }) => {

    const styleJobs = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '90%', sm: '80%' },
        // width: { xs: '85%', sm: '60%' },
        bgcolor: 'background.paper',
        border: '3px solid #3C6BA5',
        boxShadow: 24,
        p: 3,
        borderRadius: 3,
    };

    const optionsDate = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        // timeZone: 'UTC'
    };

    const navigate = useNavigate()
    const [openModal, setOpenModal] = useState(false)

    const [date1, setDate1] = useState('')
    const [date2, setDate2] = useState('')
    const [openModal1, setOpenModal1] = useState(false)
    const [openModal2, setOpenModal2] = useState(false)

    const [candidateId, setCandidateId] = useState('')
    const [selectedCandidateId, setSelectedCandidateId] = useState('');
    const [base64, setBase64] = useState([])
    const [fileName, setFileName] = useState('')
    const [fileType, setFileType] = useState('')


    // console.log("candidateId ====>>>>",candidateId )
    // console.log("selectedCandidateId ====>>>>", selectedCandidateId)

    const [selectedFile, setSelectedFile] = useState(null);

    const FileChange = (event) => {
        const file = event.target.files[0];
        // console.log("file---", event.target.files)
        if (file) {
            setFileName(file.name)
            setFileType(file.type)
            convertFileToBase64(file);
        } else {
            toast.warn('No file selected!');
        }
    };
    const convertFileToBase64 = (file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            setBase64(reader.result);
            // console.log("base64",reader.result)
        };
        reader.readAsDataURL(file);
    };

    const [greeting, setGreeting] = useState('')
    const [recipientEmail, setRecipientEmail] = useState(jobData?.emailId);
    const [subject, setSubject] = useState('');
    const [emailBody, setEmailBody] = useState('');
    const [bccEmail, setBccEmail] = useState([]);
    const [ccEmail, setCcEmail] = useState([]);
    const [uploadfilee, setUploadFile] = useState('')
    const [selectedTemplate, setSelectedTemplate] = useState({})
    const [sub1, setSub1] = useState('')
    const [sub2, setSub2] = useState('')
    const [sub3, setSub3] = useState('')
    const [body1, setBody1] = useState('')
    const [body2, setBody2] = useState('')
    const [body3, setBody3] = useState('')
    const [time1, setTime1] = useState(dayjs())
    const [time2, setTime2] = useState(dayjs())
    const [time3, setTime3] = useState(dayjs())
    const [date3, setDate3] = useState('')
    const [checked, setChecked] = useState(false);
    const [checkedEmail1, setCheckedEmail1] = useState(false);
    const [checkedEmail2, setCheckedEmail2] = useState(false);
    const [checkedEmail3, setCheckedEmail3] = useState(false);
    const sign = localStorage.getItem('sign')

    const SendEmail = () => {
        // const ebody = `<p>${greeting}${' '}${row.fullName}</p>${emailBody}`
        const token = localStorage.getItem('token')
        const bcc = [];
        const cc = [];
        bccEmail?.map((item) => {
            return bcc.push(item.title);
        });
        ccEmail?.map((item) => {
            return cc.push(item.title);
        });
        const body =
        {
            "subject": subject,
            'emailBody': `<p>${greeting}${' '}${jobData?.fullName}</p>${emailBody}${sign}`,
            "recipientEmail": recipientEmail,
            "bccEmail": bcc,
            "ccEmail": cc,
            "base64File": base64,
            "fileType": fileType,
            "fileName": fileName
        }
        Api('email/mail/instant', 'POST', body, token)
            .then(response => {
                // console.log("emailData ====>>>>>>>>>", response.data);
                if (response.status === 200) {
                    if (response.data.code === 200) {
                        handleCloseModal()
                        toast.success(response.data.message)
                        // alert('Email sent successfully!');
                        if (checked && (checkedEmail1 || checkedEmail2 || checkedEmail3)) {
                            scheduleEmail();
                        } else if (checked === true) {
                            scheduleEmail()
                            // alert("all checked")
                        }
                    } else {
                        toast.error(response.data.message)
                        // alert('Failed to send email.');
                    }
                }
            })
            .catch(error => {
                console.error('Error sending email:', error);
                // alert('Error sending email. Please try again.');
            });
    };
    const scheduleEmail = () => {
        // alert("===>>>>scheduled")
        const token = localStorage.getItem('token')
        const bcc = [];
        const cc = [];
        bccEmail?.map((item) => {
            return bcc.push(item.title);
        });
        ccEmail?.map((item) => {
            return cc.push(item.title);
        });
        const body = {
            "candidateId": selectedCandidateId,
            "templates": [
                {
                    "date": date1,
                    // "time": dayjs(time1).format('LT'),
                    "time": dayjs(time1).format('HH:mm'),
                    "subject": sub1,
                    "emailBody": `<p>${greeting}${' '}${jobData?.fullName}</p>${body1}${sign}`,
                    // "fileUrl": "base64_encoded_file_content", 
                    "recipientEmail": recipientEmail,
                    "bccEmail": bcc,
                    "ccEmail": cc,
                },
                {
                    "date": date2,
                    // "time": dayjs(time2).format('LT'),
                    "time": dayjs(time2).format('HH:mm'),
                    "subject": sub2,
                    "emailBody": `<p>${greeting}${' '}${jobData?.fullName}</p>${body2}${sign}`,
                    // "fileUrl": "base64_encoded_file_content", 
                    "recipientEmail": recipientEmail,
                    "bccEmail": bcc,
                    "ccEmail": cc,
                },
                {
                    "date": date3,
                    // "time": dayjs(time3).format('LT'),
                    "time": dayjs(time3).format('HH:mm'),
                    "subject": sub3,
                    "emailBody": `<p>${greeting}${' '}${jobData?.fullName}</p>${body3}${sign}`,
                    // "fileUrl": "base64_encoded_file_content", 
                    "recipientEmail": recipientEmail,
                    "bccEmail": bcc,
                    "ccEmail": cc,
                }
            ]
        }
        Api('email/mail/schedule', 'POST', body, token)
            .then(response => {
                try {
                    // console.log("emailData ====>>>>>>>>>", response.data);
                    if (response.status === 200) {
                        if (response.data.code === 200) {
                            toast.success(response.data.message);
                        } else if (response.data.code === 400 && response.data.message === "Emails already scheduled") {
                            toast.warn(response.data.message);
                        } else {
                            toast.error(response.data.message);
                        }
                    } else {
                        toast.error('Emails already scheduled.');
                    }
                } catch (error) {
                    console.error('Error handling response:', error);
                    toast.error('Error handling response. Please try again.');
                }
            })
            .catch(error => {
                console.error('Error sending email:', error);
                toast.error('Error sending email. Please try again.');
            });

    };

    const handleTemplateSelect = (item) => {
        // const selectedTemplate = tempList.find((item) => item.templateName === templateName);
        setSelectedTemplate(item)


        if (item && item.template && item.template.length > 0) {

            setGreeting(item.template[0].greeting)
            // console.log("selectedTemplate ====>>>>>>>", item.template[0].greeting);
            setSubject(item.template[0].subject)
            setEmailBody(item.template[0].emailBody)

            setSub1(item.template[1].subject)
            setBody1(item.template[1].emailBody)

            setSub2(item.template[2].subject)
            setBody2(item.template[2].emailBody)

            setSub3(item.template[3].subject)
            setBody3(item.template[3].emailBody)
        }
    };

    const handleChangebtn = (event) => {
        setChecked(event.target.checked);
        console.log('=========mail chk=====>>>', event.target.checked);
        setCheckedEmail1(event.target.checked);
        console.log('checkboxEmail 1=====>>>', event.target.checked);
        setCheckedEmail2(event.target.checked);
        console.log('checkboxEmail 2=====>>>', event.target.checked);
        setCheckedEmail3(event.target.checked);
        console.log('checkboxEmail 3=====>>>', event.target.checked);
        // handleChangeEmail1()
        // handleChangeEmail2()
        // handleChangeEmail3()
    };

    const handleChangeEmail1 = (event) => {
        console.log('checkboxEmail 1=====>>>', event.target.checked);
        setCheckedEmail1(event.target.checked);
    };

    const handleChangeEmail2 = (event) => {
        console.log('checkboxEmail 2=====>>>', event.target.checked);
        setCheckedEmail2(event.target.checked);
    };

    const handleChangeEmail3 = (event) => {
        console.log('checkboxEmail 3=====>>>', event.target.checked);
        setCheckedEmail3(event.target.checked);
    };

    const handleModalOpen = () => {
        setOpenModal(true);
    };

    const handleModalClose = () => {
        setOpenModal(false);
    };

    const handleModalOpen1 = () => {
        setOpenModal1(true);
    };

    const handleModalClose1 = () => {
        setOpenModal1(false);
    };

    const handleDateSelect1 = (selectedDate) => {
        // console.log(dayjs(selectedDate).format("YYYY-MM-DD"))
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        setDate1(formattedDate);
        setOpenModal(false);
    };

    const handleModalOpen2 = () => {
        setOpenModal2(true);
    };

    const handleModalClose2 = () => {
        setOpenModal2(false);
    };

    const handleDateSelect2 = (selectedDate) => {
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        // const formattedDate = selectedDate.toISOString().replace('T', ' ').split('.')[0];
        setDate2(formattedDate);
        // console.log("====>>>>>", formattedDate);
        handleModalClose1(false)
    };
    const handleDateSelect3 = (selectedDate) => {
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        // const formattedDate = selectedDate.toISOString().replace('T', ' ').split('.')[0];
        setDate3(formattedDate);
        // console.log("====>>>>>", formattedDate);
        setOpenModal2(false);
    };

    const [modalOpen, setModalOpen] = useState(false);

    const handleOpenModal = (id) => {
        setSelectedCandidateId(id);
        setModalOpen(true);
        // alert(`Selected Candidate ID: ${id}`);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const [phoneCopy, setPhoneCopy] = useState(false);
    const [emailCopy, setEmailCopy] = useState(false);


    return (
        <>
            {jobData?.map((jobData, index) => {
                return (
                    <TableRow
                        key={jobData?._id}
                        sx={[
                            {
                                background: index % 2 === 0 ? 'text.background' : tablebg,
                                '&:last-child td, &:last-child th': { border: 0 },
                                '&:hover': { boxShadow: 5 },
                            },
                        ]}
                    >
                        <TableCell sx={{}}>
                            <Typography sx={{}}>
                                Up -{' '}
                                {jobData?.updatedAt ? (
                                    `${new Date(jobData?.updatedAt).toLocaleString('en-US', optionsDate)} ${String(
                                        new Date(jobData?.updatedAt).getHours()
                                    ).padStart(2, '0')}:${String(new Date(jobData?.updatedAt).getMinutes()).padStart(2, '0')}`
                                ) : (
                                    '  '
                                )}
                            </Typography>

                            <Typography sx={{}}>
                                Cr -{' '}
                                {`${new Date(jobData?.createdAT).toLocaleString('en-US', optionsDate)} ${String(
                                    new Date(jobData?.createdAT).getHours()
                                ).padStart(2, '0')}:${String(new Date(jobData?.createdAT).getMinutes()).padStart(2, '0')}`}
                            </Typography>

                            <Stack sx={{ flexDirection: 'row' }}>
                                <Typography>-</Typography>
                            </Stack>
                        </TableCell>

                        <TableCell sx={{}}>
                            <Typography sx={{ fontWeight: 'bold', cursor: 'pointer' }} color={'text.secondary'}>
                                {jobData?.jobTitle || '-'}
                            </Typography>
                            <Typography>{jobData?.endClientOrImpPartner || '-'}</Typography>
                            <Typography>
                                {jobData?.city} , {jobData?.stateCode}
                            </Typography>
                        </TableCell>

                        <TableCell sx={{}}>
                            <Typography sx={{ fontWeight: 'bold' }} color={'text.secondary'}>
                                {jobData?.jobId || '-'}
                            </Typography>
                            <Typography>{jobData?.jobType || '-'}</Typography>
                            <Typography>{jobData?.openings || '-'}</Typography>
                        </TableCell>

                        <TableCell sx={{ py: 0, width: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <Typography>
                                {jobData?.offeredJob === 'fulltime' ? jobData?.annualSalary : jobData?.hourlyRateRateOffered}
                                {jobData?.chargeType === 'hourly' ? '/Hour' : 'K'}
                            </Typography>

                            <Typography sx={{ textTransform: 'capitalize' }} color={'text.textG'}>
                                {jobData?.taxTerm[0] || '-'}
                            </Typography>
                            <Typography sx={{ textTransform: 'capitalize' }} color={'text.textG'}>
                                {jobData?.duration || '-'}
                            </Typography>
                        </TableCell>

                        <TableCell sx={{}}>
                            <Typography>{jobData?.recruitorName || '-'}</Typography>
                            <Typography>
                                {jobData?.recruiterEmail || '-'}
                                {jobData?.recruiterEmail && (
                                    <CopyToClipboard text={jobData.recruiterEmail} onCopy={() => setEmailCopy(true)}>
                                        <Iconify
                                            icon="radix-icons:copy"
                                            color={emailCopy ? 'text.secondary' : 'text.textG'}
                                            sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer', mb: -0.4 }}
                                        />
                                    </CopyToClipboard>
                                )}
                            </Typography>
                            <Typography>
                                {jobData?.recruiterPhoneNumber || '-'}
                                {jobData?.recruiterPhoneNumber && (
                                    <CopyToClipboard text={jobData?.recruiterPhoneNumber?.trim()} onCopy={() => setPhoneCopy(true)}>
                                        <Iconify
                                            icon="radix-icons:copy"
                                            color={phoneCopy ? 'text.secondary' : 'text.textG'}
                                            sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer', mb: -0.4 }}
                                        />
                                    </CopyToClipboard>
                                )}
                            </Typography>
                        </TableCell>

                        <TableCell sx={{}}>
                            <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                                <Iconify icon="ic:baseline-email" fontSize={10} />
                                <Typography sx={{}} onClick={() => handleOpenModal(jobData?._id)}>
                                    Email
                                </Typography>
                            </Stack>
                            <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                                <Iconify icon="bx:support" fontSize={10} />
                                <Typography sx={{}}>Contact</Typography>
                            </Stack>

                            {jobData.userStatus !== 'fake' && jobData.userStatus !== 'blacklisted' ? (
                                <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                                    {jobData.startStatus !== 'quit' && jobData.startStatus !== 'terminated' && jobData.startStatus !== 'project ended' ? (
                                        <Iconify icon="icon-park-solid:check-one" fontSize={10} />
                                    ) : (
                                        <Typography sx={{ color: 'transparent' }}>cdcd</Typography>
                                    )}
                                    <Typography
                                        onClick={() =>
                                            navigate('/benchresumedetails', {
                                                state: {
                                                    jobData,
                                                    fTab: 'submitted',
                                                    ...(jobData.status === 'placement' && { openModal: 'editOrNot' }),
                                                },
                                            })
                                        }
                                    >
                                        {jobData.status === 'prospect' ? 'Submit' : 'Resubmit'}
                                    </Typography>
                                </Stack>
                            ) : (
                                <Typography sx={{ color: 'transparent' }}>cdcd</Typography>
                            )}
                        </TableCell>
                    </TableRow>
                );
            })}

            <Modal open={modalOpen} onClose={handleCloseModal} style={{ borderRadius: 10 }}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '95%', sm: '70%' },
                    // width: { xs: '85%', sm: '60%' },
                    bgcolor: 'background.paper',
                    border: '3px solid #3C6BA5',
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 3,
                }}
                >
                    <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
                        Send Email
                    </Typography>
                    <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
                        {/* <Divider sx={{ mb: 2 }} /> */}
                        <Grid container spacing={1} mt={1}>
                            <Grid item xs={5.9}>
                                <TextField
                                    fullWidth
                                    required
                                    label="To"
                                    variant="outlined"
                                    size="small"
                                    // value={to}
                                    value={recipientEmail}
                                    // onChange={(e) => setTo(e.target.value)}
                                    onChange={(e) => setRecipientEmail(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={5.9}>
                                <Autocomplete
                                    size='small'
                                    multiple
                                    id="tags-outlined"
                                    onChange={(event, newValue) => {
                                        setCcEmail([...newValue]);
                                    }}
                                    options={[{ title: '' }]}
                                    getOptionLabel={(option) => option.title}
                                    value={ccEmail?.map((item) => item)}
                                    filterSelectedOptions
                                    filterOptions={(options, params) => {
                                        const filtered = filter(options, params);
                                        const { inputValue } = params;
                                        // Suggest the creation of a new value
                                        const isExisting = options.some((option) => inputValue === option.title);
                                        if (inputValue !== '' && !isExisting) {
                                            filtered.push({
                                                inputValue,
                                                title: `${inputValue}`,
                                            });
                                        }
                                        return filtered;
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Cc" placeholder="Cc"

                                        size="small"
                                    />}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} mt={1}>
                            <Grid item xs={5.9}>
                                <Autocomplete
                                    size='small'
                                    multiple
                                    id="tags-outlined"
                                    onChange={(event, newValue) => {
                                        setBccEmail([...newValue]);
                                    }}
                                    options={[{ title: '' }]}
                                    getOptionLabel={(option) => option.title}
                                    value={bccEmail?.map((item) => item)}
                                    filterSelectedOptions
                                    filterOptions={(options, params) => {
                                        const filtered = filter(options, params);
                                        const { inputValue } = params;
                                        // Suggest the creation of a new value
                                        const isExisting = options.some((option) => inputValue === option.title);
                                        if (inputValue !== '' && !isExisting) {
                                            filtered.push({
                                                inputValue,
                                                title: `${inputValue}`,
                                            });
                                        }
                                        return filtered;
                                    }}
                                    renderInput={(params) => <TextField {...params} label="BCc" placeholder="BCc"

                                        size="small"
                                    />}
                                />

                            </Grid>

                            <Grid item xs={5} sx={{}}>
                                <FormControl variant="outlined" fullWidth size="small" >
                                    <InputLabel >Select Template</InputLabel>
                                    <Select
                                        label="Select Template"
                                        // value={formValues.resource}
                                        onChange={(e) => handleTemplateSelect(e.target.value)}

                                    >
                                        {tempList?.map((item) => (
                                            <MenuItem key={item.id} value={item}>
                                                {item.templateName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Typography
                                // component={Button}
                                // onClick={() => { navigate('/Email'),{ state: { undid:"undid" } } }}
                                onClick={() => navigate('/Email', { state: { undid: "undid" } })}

                                sx={{
                                    color: '#23A6F0',
                                    fontWeight: 'bold',
                                    fontSize: '17px',
                                    marginLeft: '30px',
                                    marginTop: '18px',
                                    cursor: 'pointer',
                                }}
                            >
                                Edit
                            </Typography>
                        </Grid>
                        <Grid container alignItems="center" style={{ flexDirection: 'row' }}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                                <Typography sx={{ ml: 1, color: '#1E74B3' }}>Attachment:</Typography>
                                <input type="file" onChange={FileChange} style={{ marginLeft: '9px' }} />
                                {/* <Button variant="contained" onClick={UploadFile}>
          Upload
      </Button> */}
                            </Grid>
                        </Grid>

                        <Grid container spacing={1}>
                            <Grid item xs={11.8}>
                                <TextField
                                    label='Sub'
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    size="small"
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                    InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                                />
                            </Grid>
                            <Grid item xs={11.8}>
                                <Stack sx={{ flexDirection: 'row', gap: 1, alignItems: 'center' }}>

                                    <Typography> {greeting} {jobData?.fullName}</Typography>
                                </Stack>
                            </Grid>
                            <Grid item xs={11.8}>
                                <CKEditor
                                    data={emailBody}
                                    config={{
    // licenseKey: process.env.REACT_APP_TLK,
    // toolbar: [
    //   'heading', '|',
    //   'bold', 'italic', 'link', '|',
    //   'insertImage', 'undo', 'redo'
    // ],
    extraPlugins: [ MyCustomUploadAdapterPlugin ]
  }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        console.log("body", data)
                                        setEmailBody(data);
                                    }}
                                    editor={ClassicEditor}
                                />
                            </Grid>
                        </Grid>
                        <Stack>

                            <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
                        </Stack>

                        <Stack flexDirection={'row'} gap={1} mt={1} sx={{ justifyContent: 'space-between', alignItems: 'center', px: 2 }}>
                            <Stack sx={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <Typography sx={{ fontSize: '1rem', fontWeight: 'bold' }}>Automailer</Typography>
                                <Switch checked={checked} onChange={handleChangebtn} inputProps={{ 'aria-label': 'controlled' }} />
                            </Stack>
                            {checked && (<Typography sx={{ fontWeight: 'bold', color: '#2ECC71' }}>Automailer Activated !</Typography>)}
                        </Stack>

                        <Grid container spacing={1} alignItems="center">
                            <Grid item xs="auto">
                                <Checkbox
                                    checked={checkedEmail1}
                                    onChange={handleChangeEmail1}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }}
                                />
                            </Grid>
                            <Grid item xs={5.8}>
                                <TextField
                                    disabled
                                    label="Email 1"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    size="small"
                                    value={sub1}
                                    InputProps={{ style: { borderRadius: '10px' } }}
                                />
                            </Grid>

                            <Grid item xs={2}>
                                <FormControl fullWidth sx={{ mt: 1 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimePicker
                                            ampm={false}
                                            slotProps={{ textField: { size: 'small' } }}
                                            value={time1}
                                            onChange={(newValue) => setTime1(newValue)}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2}>
                                <TextField
                                    label="Date"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    size="small"
                                    value={date1}
                                    onChange={(e) => setDate1(e.target.value)}
                                    InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                                />
                            </Grid>
                            <Grid item xs="auto">
                                <IconButton
                                    onClick={handleModalOpen}
                                    sx={{
                                        color: '#1E74B3',
                                        padding: '10px',
                                        borderRadius: '15%',
                                        width: '90px',
                                        height: '35px',
                                        marginTop: '7%',
                                        backgroundColor: '#1E74B3',
                                        '&:hover': { backgroundColor: '#E6F3FD' }
                                    }}
                                >
                                    <Icon icon="noto:calendar" />
                                </IconButton>
                            </Grid>
                        </Grid>

                        <Modal
                            open={openModal}
                            onClose={handleModalClose}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Box sx={{
                                width: '24%',
                                height: '53%',
                                overflowY: 'auto',
                                backgroundColor: 'white',
                                borderRadius: '10px',
                                border: '2px solid #1E74B3'
                            }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateCalendar
                                        disablePast
                                        date={dayjs(date1)}
                                        onChange={handleDateSelect1}
                                    />
                                </LocalizationProvider>
                            </Box>
                        </Modal>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item xs="auto">
                                <Checkbox
                                    checked={checkedEmail2}
                                    onChange={handleChangeEmail2}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }}
                                />
                            </Grid>
                            <Grid item xs={5.8} >
                                <TextField
                                    disabled
                                    label="Email 2"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    size="small"
                                    value={sub2}
                                    InputProps={{ style: { borderRadius: '10px' } }}
                                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                                />
                            </Grid>

                            <Grid item xs={2}>
                                <FormControl fullWidth sx={{ mt: 1 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimePicker
                                            ampm={false}
                                            slotProps={{ textField: { size: 'small' } }}
                                            value={time2}
                                            onChange={(newValue) => setTime2(newValue)}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2}>

                                <TextField
                                    label="Date"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    size="small"
                                    value={date2}
                                    onChange={(e) => setDate2(e.target.value)}
                                    InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                                />
                            </Grid>

                            <Grid item xs="auto">
                                <IconButton
                                    onClick={handleModalOpen1}
                                    sx={{
                                        color: '#1E74B3',
                                        padding: '10px',
                                        borderRadius: '15%',
                                        width: '90px',
                                        height: '35px',
                                        marginTop: '7%',
                                        backgroundColor: '#1E74B3',
                                        '&:hover': { backgroundColor: '#E6F3FD' }
                                    }}
                                >
                                    <Icon icon="noto:calendar" />
                                </IconButton>
                            </Grid>

                            <Modal
                                open={openModal1}
                                onClose={handleModalClose1}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <Box sx={{
                                    width: '24%',
                                    height: '53%',
                                    overflowY: 'auto',
                                    backgroundColor: 'white',
                                    borderRadius: '10px',
                                    border: '2px solid #1E74B3'

                                }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateCalendar
                                            disablePast
                                            date={dayjs(date2)}
                                            onChange={handleDateSelect2}
                                        />
                                    </LocalizationProvider>

                                </Box>
                            </Modal>

                        </Grid>

                        <Grid container spacing={1} alignItems="center">
                            <Grid item xs="auto">
                                <Checkbox
                                    checked={checkedEmail3}
                                    onChange={handleChangeEmail3}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }}
                                />
                            </Grid>
                            <Grid item xs={5.8}>

                                <TextField
                                    disabled
                                    label="Email 3"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    size="small"
                                    value={sub3}
                                    // onChange={(e) => setEmail2(e.target.value)}
                                    InputProps={{ style: { borderRadius: '10px' } }}
                                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl fullWidth sx={{ mt: 1 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimePicker
                                            ampm={false}
                                            slotProps={{ textField: { size: 'small' } }}
                                            value={time3}
                                            onChange={(newValue) => setTime3(newValue)}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2}>
                                <TextField
                                    label="Date"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    size="small"
                                    value={date3}
                                    onChange={(e) => setDate3(e.target.value)}
                                    InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                                />
                            </Grid>

                            <Grid item xs="auto">
                                <IconButton
                                    onClick={handleModalOpen2}
                                    sx={{
                                        color: '#1E74B3',
                                        padding: '10px',
                                        borderRadius: '15%',
                                        width: '90px',
                                        height: '35px',
                                        marginTop: '7%',
                                        backgroundColor: '#1E74B3',
                                        '&:hover': { backgroundColor: '#E6F3FD' }
                                    }}
                                >
                                    <Icon icon="noto:calendar" />
                                </IconButton>
                            </Grid>

                            <Modal
                                open={openModal2}
                                onClose={handleModalClose2}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <Box sx={{
                                    width: '24%',
                                    height: '53%',
                                    overflowY: 'auto',
                                    backgroundColor: 'white',
                                    borderRadius: '10px',
                                    border: '2px solid #1E74B3',

                                }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateCalendar
                                            disablePast
                                            date={dayjs(date3)}
                                            onChange={handleDateSelect3}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Modal>

                        </Grid>

                        <Stack flexDirection={'row'} gap={1} mt={1} sx={{ justifyContent: 'center' }}>
                            <Button
                                color="custom"
                                variant="contained"
                                onClick={SendEmail}
                                disabled={recipientEmail === '' || subject === ''}
                            >
                                Send
                            </Button>
                        </Stack>
                    </Scrollbar>
                </Box>
            </Modal>
        </>
    );
};


function Search({ searchData, func, funcc, funnc, onData, resetSearch, onData1, onData2 }) {

    const StyledIconButtonWrapper = styled('div')({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 'bold',
    });

    const [formValues, setFormValues] = useState({

        //   jobTitle: [],
        jobTitle: '',
        city: "",
        state: "",
        country: "",
        stateCode: ""
    });

    const [formValues1, setFormValues1] = useState({ jobTitle: "" });

    const toggleVisibility = () => {
        // setIsVisible(!isVisible); 
        resetSearch()
        func()
        setFormValues1({ ...formValues1, jobTitle: '' });
        setFormValues({
            ...formValues,
            jobTitle: '',
            city: "",
            state: "",
            country: "",
            stateCode: ""

        });
        setCityQuery('')
        setStateQuery('')

    };

    const [loadingData, setLoadingData] = useState('')

    const fn = (page = 1) => {
        setLoading(true);
        setLoadingData('Loading...')
        const token = localStorage.getItem('token');
        const body = {
            "jobTitle": formValues.jobTitle,
            "city": cityQuery,
            "stateCode": stateCode,
            "country": "",
            "page": page,
            "limit": "50",
            "state": "",
        }

        Api('bench/openJob', 'POST', body, token)
            .then((response) => {
                console.log('Response:---------', response);
                if (response.status === 200) {
                    if (response.data.status === 200) {

                        const totalPage = Math.ceil(response.data?.count / 35)
                        searchData(response.data?.newArray, response?.data?.count, totalPage)
                        setLoadingData('');
                        setLoading(false);
                        //   console.log("response.data.data", response.data.data)
                    } else {
                        console.log('Error:', response.data.message);
                        //   searchData([])
                        setLoadingData('No data found');
                        setLoading(false);
                        searchData(({ noData: "noData" }))
                    }

                    handleSearchClose()
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const [loading1, setLoading1] = useState(false);

    const searchfn = (page = 1) => {
        setLoading1(true)
        const body = {
            "jobTitle": formValues1.jobTitle,
            "page": page,
            "limit": "50",
        }
        const token = localStorage.getItem('token');
        Api('bench/openJob', 'POST', body, token)
            .then((response) => {
                console.log('Response:---------', response);
                if (response.status === 200) {
                    if (response.data.status === 200) {

                        const totalPage = Math.ceil(response.data.count / 35)
                        searchData(response.data?.newArray, response?.data?.count, totalPage)
                        setLoading1(false);
                        // alert("ll")

                    } else {
                        setLoading1(false);
                        searchData(({ noData: "noData" }))
                        // setLoadingData('No data found');
                        // console.log('Error:', response.data.message);
                    }
                    // handleClose()

                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const [searchOpen, setSearchOpen] = useState(false);

    const handleSearchOpen = () => {
        setSearchOpen(true);
    };

    const handleSearchClose = () => {
        setSearchOpen(false);
    };

    const [dist, setDistance] = useState('')
    const [latt, setLatt] = useState('')
    const [long, setLong] = useState('')
    const [valuee, setValue] = useState({ country: localStorage.getItem("country") });
    const [cityData, setCityData] = useState([]);
    const [cityQuery, setCityQuery] = useState("");
    const [cityAndState, setCityAndState] = useState(null);
    const [stateCode, setStateCode] = useState('')

    console.log("cityData", cityData)
    console.log("cityQuery===>>>", cityQuery)
    console.log("cityAndState", cityAndState)

    const handleChange = (e) => {
        setValue({ country: e.target.value });
    };

    const [err, setErr] = useState(false); 
  const [helperText, setHelperText] = useState('');
    const getCity = async (val) => {
        setHelperText('')
    setErr(false)
        const token = localStorage.getItem('token');
        const body = {
            country: valuee.country || localStorage.getItem("country"),
            query: val,
        };
        try {
            const response = await Api('resume/get_city_states', 'POST', body, token);
            if (response.status === 200 && response.data.code === 200) {
                setCityData(response.data.data || []);
                console.log("response.data.data", response.data.data)

            } else {
                console.error(response.data.message);
                // toast.error(response.data.message)
                setHelperText("No cities found for the given city name.")
        setErr(true)
                setCityData([]);
            }
        } catch (err) {
            console.error(err);
            setCityData([]);
        }

    };

    const childFuc = (val) => {
        setCityData([])
        console.log("vall===", val)
        if (typeof (val) === "string") {
            console.log("val", val)
            // alert("USA")
            if (val.length >= 3) {
                getCity(val);
            }

            setCityQuery(val);
            // handleCityChange(val);
        }
        else {
            // alert("CAN") 
            if (val.city.length >= 3) {
                getCity(val.city);
            }
            setStateQuery(val?.state)
            setCityQuery(val?.city);
            // handleCityChange(val.city);
            setLatt(val?.lat);
            setLong(val?.lng);
            setStateCode(val?.stateCode || val?.postal)
        }

    };

    const [stateData, setStateData] = useState([]);
    const [stateQuery, setStateQuery] = useState("");
    const [stateId, setStateId] = useState("");
    const [selectedState, setSelectedState] = useState(null);

    console.log("====stateQuery======", stateQuery)
    console.log("====stateData======", stateData)
    const handleStateChange = async (val) => {
        console.log("=======", val)
        // alert("hh")
        setStateQuery(val?.state_name || val?.province_or_StateName);
        setStateId(val?.state_id || val?.province_id)
        // await getState(val);
        // console.log("val====",val)
        if (val.length >= 3) {
            await getState(val);
        }
    };

    const getState = async (val) => {
        const token = localStorage.getItem('token');
        const body = {
            country: valuee.country,
            stateName: val,
        };
        try {
            const response = await Api('resume/get_states', 'POST', body, token);
            if (response.status === 200 && response.data.code === 200) {
                setStateData(response.data.data || []);

            } else {
                console.error(response.data.message);
                setStateData([]);
            }
        } catch (err) {
            console.error(err);
            setStateData([]);
        }
    };

    const childFucState = async (val) => {
        console.log("stateval", val)
        setStateQuery(val?.state_name || val?.province_or_StateName);
        handleStateChange(val);

    };

    console.log("latt==>>", latt)
    console.log("long==>>", long)
    console.log("dist==>>", dist)

    // const handleSearch = () => {
    //   if (dist) {
    //     // searchDis();
    //     setDistance('')
    //     // setStateQuery('')
    //     // setCityQuery('')
    //     // setValue('')
    //     setStateCode('')

    //   } else {
    //     setStateCode('')
    //     fn();
    //     setDistance('')
    //     // setStateQuery('')
    //     // setCityQuery('')
    //     // setValue('')
    //   }
    // };

    const clearInputField = () => {
        setFormValues({
            ...formValues,
            jobTitle: '',
            city: '',
            state: '',
            stateCode: ""

        });
        setCityQuery('')
        setStateQuery('')
        setDistance('')
        setStateCode('')

    }

    const [cityStateStyling, setCityStateStyling] = useState(false)

    const sendDataToParent = () => {
        onData(clearInputField);
    };

    const [loading, setLoading] = useState(false);
    const sendDataToParent1 = () => {
        onData1(fn, loadingData);
    };

    const [pageNumber, setPageNumber] = useState(1)

    const sendDataToParent2 = () => {
        onData2(pageNumber);
    };

    return (
        <>
            <>

                <div style={{ display: 'flex', alignItems: 'center', left: 115, right: 0 }}>
                    <Paper
                        component="form"
                        sx={{
                            // p: '2px 4px',
                            display: 'flex',
                            alignItems: 'center',
                            width: '25%',
                            border: '1px solid #1E74B3',
                            borderRadius: '10px',
                            marginTop: -18,
                        }}
                    >

                        <InputBase
                            sx={{ flex: 1, color: 'text.primary', border: 'none', outline: 'none', pl: 1 }}

                            placeholder="Job Title"
                            inputProps={{ 'aria-label': 'search' }}
                            value={formValues1.jobTitle}
                            onChange={(e) => setFormValues1({ ...formValues1, jobTitle: e.target.value })}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    searchfn();
                                    funcc();
                                    sendDataToParent1()
                                }

                            }}
                        />
                    </Paper>
                    <Button color="custom" variant="contained" size="small" sx={{ ml: 1.6, mt: -18 }}
                        disabled={loading1}
                        onClick={() => { searchfn(); funcc() }}

                    >
                        {loading1 ? <CircularProgress size={24} /> : 'Search'}
                    </Button>
                    {(

                        //   formValues1?.jobTitle.length > 0 ||
                        //   formValues?.jobTitle.length > 0 ||
                        formValues1?.jobTitle ||
                        formValues?.jobTitle ||
                        formValues?.city ||
                        formValues?.state ||
                        cityQuery || stateQuery
                    ) && (

                            <Button color="custom" variant="contained" size="small" sx={{ ml: 1.6, mt: -18 }}
                                onClick={() => { toggleVisibility(); funnc(); sendDataToParent2() }}>
                                Close
                            </Button>
                        )}

                </div>

                <StyledIconButtonWrapper onClick={() => {
                    handleSearchOpen();
                    setCityStateStyling(true);
                    sendDataToParent()
                }}>

                    <IconButton sx={{ display: 'flex', position: 'absolute', top: 55, marginRight: '68%' }}>
                        <Iconify
                            icon="bxs:down-arrow"
                            color="#1E74B3"
                        />
                    </IconButton>
                </StyledIconButtonWrapper>

                <Modal open={searchOpen} onClose={handleSearchClose}>

                    <Box sx={{
                        position: 'absolute',
                        top: '27.3%',
                        left: '43%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: '95%', sm: '70%' },
                        // width: { xs: '85%', sm: '60%' },
                        bgcolor: 'background.paper',
                        border: '3px solid #3C6BA5',
                        boxShadow: 24,
                        p: 2,
                        borderRadius: 3,
                    }}
                    >

                        <Grid container spacing={1} justifyContent="center">

                            {/* <Grid item xs={6}>
                  <Autocomplete
                    multiple
                    size="small"
                    id="job-title-autocomplete"
                    options={formValues.jobTitle}
                    value={formValues.jobTitle}
                    onChange={(e, newValue) => setFormValues({ ...formValues, jobTitle: newValue })}
                    filterSelectedOptions
                    filterOptions={(options, params) => {
                      const inputValue = params.inputValue.trim().toLowerCase();
  
                      if (inputValue !== '' && !options.some((option) => option.toLowerCase() === inputValue)) {
                        options.push(inputValue);
                      }
  
                      return options.filter((option) =>
                        option.toLowerCase().includes(inputValue)
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Job Titles"
                        variant="outlined"
                        fullWidth
                        size="small"
                        placeholder="Search or enter job titles"
                      />
                    )}
                  />
                </Grid>      */}

                            <Grid item xs={6}>
                                <TextField
                                    label="Job Title"
                                    variant="outlined"
                                    fullWidth
                                    // margin="dense"
                                    size="small"
                                    value={formValues.jobTitle}
                                    onChange={(e) => setFormValues({ ...formValues, jobTitle: e.target.value })}

                                />
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl variant="outlined" fullWidth size="small">
                                    <InputLabel>Select Country</InputLabel>
                                    <Select
                                        value={valuee.country}
                                        onChange={handleChange}
                                        label="Select Country"
                                    >
                                        <MenuItem value="USA">USA</MenuItem>
                                        <MenuItem value="CANADA">CANADA</MenuItem>
                                         <MenuItem value={'INDIA'}>INDIA</MenuItem>;
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={6} >
                                <CustomCompleteWorksheet
                                    // <CustomComplete
                                    placeholder={'City'}
                                    size="small"
                                    option={cityData}
                                    propVal={cityQuery}
                                    childFuc={childFuc}
                                    fetch={'state'}
                                    cityStateStyling1={cityStateStyling}
                                    err={err}
                                    helperText={helperText}
                                    
                                />
                            </Grid>

                            <Grid item xs={6} size="small">
                                <CustomComplete
                                    placeholder={'State'}
                                    size="small"
                                    option={stateData}
                                    propVal={stateQuery}
                                    childFuc={childFucState}
                                    cityStateStyling1={cityStateStyling}
                                    err={err}
                                    helperText={helperText}
                                    
                                />

                                <FormControl fullWidth size="small">
                                    {selectedState ? (
                                        <Stack sx={{ ml: 1, mb: 2, mt: -1, flexDirection: 'row' }}>
                                            <Typography color="text.secondary" variant="body1">
                                                {/* {selectedState.state_name} */}
                                            </Typography>
                                        </Stack>
                                    ) : null}
                                </FormControl>
                            </Grid>

                            <Grid item xs={6} textAlign="center" sx={{ mt: -1.2 }}>

                                <Button color="custom" variant="contained" size="small" disabled={loading}
                                    onClick={() => {
                                        // handleSearch(); funcc(); sendDataToParent1()
                                        fn()
                                    }}

                                >

                                    {loading ? <CircularProgress size={24} /> : 'Search'}
                                </Button>
                                <Button color="custom" variant="contained" size="small"
                                    sx={{ marginLeft: '12px' }}
                                    onClick={clearInputField}>
                                    Clear All
                                </Button>

                            </Grid>
                        </Grid>
                    </Box>
                </Modal>

            </>

        </>
    );

}